import { Column, Entity, Index } from 'typeorm';
import { BaseEntity } from './base.entity';

@Entity('_messaging_conversation')
@Index('idx_messaging_conversation_external', [
	'sourceIdentifier',
	'externalIdentifier',
])
export class MessagingConversationEntity extends BaseEntity {
	@Column({
		name: 'uuid',
		type: 'varchar',
		length: 36,
		nullable: false,
	})
	@Index({ unique: true })
	public uuid!: string;

	@Column({
		name: 'name',
		type: 'varchar',
		length: 255,
		nullable: true,
	})
	public name?: string;

	@Column({
		name: 'is_direct',
		type: 'boolean',
		default: false,
		nullable: false,
		comment: 'True for 1:1 direct messages, false for group conversations',
	})
	public isDirect!: boolean;

	@Column({
		name: 'is_public',
		type: 'boolean',
		default: false,
		nullable: false,
	})
	public isPublic!: boolean;

	@Column({
		name: 'source_identifier',
		type: 'varchar',
		length: 50,
		nullable: true,
		comment:
			'Our provisioned identifier (phone/email) for outbound communication',
	})
	@Index()
	public sourceIdentifier?: string;

	@Column({
		name: 'external_identifier',
		type: 'varchar',
		length: 50,
		nullable: true,
		comment:
			'External party identifier (phone/email) for external conversations',
	})
	@Index()
	public externalIdentifier?: string;

	@Column({
		name: 'linked_entity_type',
		type: 'varchar',
		length: 100,
		nullable: true,
	})
	@Index()
	public linkedEntityType?: string;

	@Column({
		name: 'linked_entity_id',
		type: 'int',
		unsigned: true,
		nullable: true,
	})
	@Index()
	public linkedEntityId?: number;

	@Column({
		name: 'fk_messaging_message__id',
		type: 'int',
		unsigned: true,
		nullable: true,
		comment: 'Latest message in the conversation',
	})
	public latestMessageId?: number;

	@Column({
		name: 'last_message_at',
		type: 'timestamp',
		nullable: true,
	})
	public lastMessageAt?: Date;

	@Column({
		name: 'message_count',
		type: 'int',
		unsigned: true,
		default: 0,
		nullable: false,
	})
	public messageCount!: number;

	@Column({
		name: 'metadata',
		type: 'json',
		nullable: true,
	})
	public metadata?: Record<string, unknown>;
}
